import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  Star as StarIcon,
  Close as CloseIcon,
  Headphones as HeadphonesIcon,
  Tune as TuneIcon,
  MusicNote as MusicNoteIcon,
  GraphicEq as GraphicEqIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const FEATURES = [
  { icon: <HeadphonesIcon />, labelKey: 'pro.features.metronome' },
  { icon: <TuneIcon />, labelKey: 'pro.features.tuner' },
  { icon: <MusicNoteIcon />, labelKey: 'pro.features.capoHelper' },
  { icon: <GraphicEqIcon />, labelKey: 'pro.features.pad' },
];

const ProUpgradeModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  const handleSubscribe = () => {
    alert(t('pro.comingSoonMessage', 'PRO subscriptions will be available soon via the App Store and Google Play.'));
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <IconButton
        onClick={onClose}
        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ textAlign: 'center', pt: 4, pb: 2 }}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: 'rgba(162, 89, 255, 0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <StarIcon sx={{ fontSize: 32, color: '#FFD700' }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
          {t('pro.title', 'Upgrade to PRO')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {t('pro.subtitle', 'Unlock all practice tools and take your worship to the next level.')}
        </Typography>

        <List sx={{ mb: 2 }}>
          {FEATURES.map((f, i) => (
            <ListItem key={i} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, color: 'primary.main' }}>
                {f.icon}
              </ListItemIcon>
              <ListItemText primary={t(f.labelKey, f.labelKey.split('.').pop())} />
            </ListItem>
          ))}
        </List>

        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', mb: 0.5 }}>
          <Typography variant="h3" color="primary" sx={{ fontWeight: 'bold' }}>
            $1.99
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
            /{t('pro.month', 'month')}
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">
          {t('pro.cancelAnytime', 'Cancel anytime. No commitment.')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', gap: 1, pb: 3, px: 3 }}>
        <Button
          variant="contained"
          fullWidth
          size="large"
          startIcon={<StarIcon />}
          onClick={handleSubscribe}
          sx={{ bgcolor: '#a259ff', '&:hover': { bgcolor: '#8a3de0' } }}
        >
          {t('pro.subscribe', 'Subscribe to PRO')}
        </Button>
        <Button size="small" color="inherit" onClick={onClose}>
          {t('pro.restorePurchases', 'Restore Purchases')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProUpgradeModal;
